import { useBrowerSuggestionTip } from "@uiview/views/BrowerSuggestionTip/useBrowerSuggestionTip";
import { useLocation, useNavigate } from "react-router-dom";
import { FotProcessStore } from "@uikit/store/FotProcessStore";
import { FotUserAuthService } from "@uikit/service/FotUserAuthService";
import { SubscriberService, subscriberService } from "@uikit/imagicaApp/SubscriberService";
import { FotReduxStore } from "@uikit/store/FotReduxStore";
import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";
import { HomePluginStore } from "imagica-corekit/dist/base/store/HomePluginStore";
import func from "@uikit/func";
import { getIt } from "@uikit/getIt";
import { PreferencesStore } from "imagica-corekit/dist/base/store/PreferencesStore";
import { creatorRefStore } from "@uiview/views/ProjectCanvas/store/CreatorRefStore";
import { UiFunctionService } from "@uikit/service/UiFunctionService";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { creatorCotStore } from "@uiview/views/ProjectCanvas/store/CreatorCotStore";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { MeStore } from "imagica-corekit/dist/base/store/MeStore";
import { SubscriptionStore } from "imagica-corekit/dist/cases/store/SubscriptionStore";
import { PersonalFunctionStore } from "imagica-corekit/dist/base/store/PersonalFunctionStore";
import { FotProcessUIParam } from "@uikit/fotProcess/modles";
import { ProcessLang } from "@uikit/fotProcess/ProcessLang";
import { ProcessBoarding } from "@uikit/fotProcess/ProcessBoarding";
import { ProcessShareDomain } from "@uikit/fotProcess/ProcessShareDomain";
import { ProcessUserAuth } from "@uikit/fotProcess/ProcessUserAuth";
import { logEvent } from "@uikit/service/amplitude";
import { WebConfigStore } from "imagica-corekit/dist/cases/webconfig/WebConfigStore";
import { useEffect } from "react";

let instance: FotProcessManager;
function useProcessManager(): FotProcessManager {
  const location = useLocation();
  const navigate = useNavigate();
  const { setBrowerSuggestionTip } = useBrowerSuggestionTip();

  if (!instance) {
    const processLang = new ProcessLang(getIt(FotAuthStore), getIt(HomePluginStore), window.sessionStorage);
    const processBoarding = new ProcessBoarding(
      getIt(FotReduxStore),
      getIt(FotAuthStore),
      getIt(PreferencesStore),
      getIt(HomePluginStore),
      creatorRefStore,
      getIt(UiFunctionService),
      getIt(FotUserAuthService),
      getIt(HomeStore),
      creatorCotStore
    );
    const processShareDomain = new ProcessShareDomain(settings, getIt(FotReduxStore), getIt(HomePluginStore));
    const processUserAuth = new ProcessUserAuth(
      processShareDomain,
      getIt(FotUserAuthService),
      getIt(FotReduxStore),
      getIt(FotAuthStore),
      getIt(MeStore),
      getIt(PreferencesStore),
      getIt(SubscriptionStore),
      getIt(PersonalFunctionStore)
    );

    instance = new FotProcessManager(
      getIt(FotProcessStore),
      getIt(FotReduxStore),
      getIt(FotUserAuthService),
      subscriberService,
      processLang,
      processBoarding,
      processShareDomain,
      processUserAuth,
      new FotProcessUIParam(location, window.location, window.history, window.sessionStorage)
    );
  }

  useEffect(() => {
    instance.fotProcessUIParam.localLocation = location;
    instance.fotProcessUIParam.location = window.location;
    instance.fotProcessUIParam.sessionStorage = window.sessionStorage;
    instance.fotProcessUIParam.history = window.history;
    instance.fotProcessUIParam.navigate = navigate;
    instance.fotProcessUIParam.setBrowerSuggestionTip = setBrowerSuggestionTip;
  });

  return instance;
}
export class FotProcessManager {
  static use = useProcessManager;

  constructor(
    public fotProcessStore: FotProcessStore,
    public fotReduxStore: FotReduxStore,
    public fotUserAuthService: FotUserAuthService,
    public subscriberService: SubscriberService,
    // process
    public processLang: ProcessLang,
    public processBoarding: ProcessBoarding,
    public processShareDomain: ProcessShareDomain,
    public processUserAuth: ProcessUserAuth,
    public fotProcessUIParam: FotProcessUIParam
  ) {}

  async init(): Promise<void> {
    try {
      this.fotProcessStore.startLoading();

      this.fotUserAuthService.init();

      await this.subscriberService.init();

      const isShare = await this.processShareDomain.init(this.fotProcessUIParam.localLocation.pathname);
      await this.onShare(isShare);

      await this.processUserAuth.init(this.fotProcessUIParam);

      await this.processBoarding.init();
    } catch (error) {
      console.error("init error", error);
      func.messageUtil("Init page failed");
    }

    this.fotProcessStore.overLoading();
    this.fotReduxStore.setIsLogin(this.processLang.isAuth());
  }

  async onShare(isShare: boolean): Promise<void> {
    //如果是creator,清空GUEST_TOKEN，修复BSF-7328
    if (!isShare) {
      this.fotProcessUIParam.sessionStorage.removeItem("GUEST_TOKEN");
      await getIt(WebConfigStore).get();
      getIt(SubscriptionStore).renew();
    }

    this.fotProcessUIParam.setBrowerSuggestionTip?.(isShare);
  }

  logout(): void {
    logEvent("logout");

    this.processUserAuth.logout();

    this.fotProcessUIParam.navigate?.("/signin");
  }
}
